import React from "react";
import Typography from '@mui/material/Typography';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const DataSelector = (props) =>{

    return (
        <React.Fragment>
            <Typography variant={"h6"}> {props.title} </Typography> 
            <DatePicker
                selected={props.selected}
                selectsStart={props.isStart}
                selectsEnd={props.isEnd}
                startDate={props.startDate}
                endDate={props.endDate}
                onChange={props.onChange}
                dateFormat="yyyy/MM/dd"
            />
        </React.Fragment>

    );
} 

export default DataSelector;
